export enum CapitalizationDataCellBlock {
  Root = 'CapitalizationDataCell',
  TooltipText = 'TooltipText',
}
